import React, { useEffect, useRef, useState } from "react";
import "./PaymentReport.scss";
import { useTable } from "react-table";
import { useDispatch, useSelector } from "react-redux";
import { deleteCoupon } from "../../store/reducers/couponSlice";
import { getPaymentList, getPaymentReport } from "../../utils/api/apis";
import { ReactComponent as SearchNew } from "../../assets/icons/search-svgrepo-com (1).svg";
import { ReactComponent as CopyIcon } from "../../assets/icons/CopyIcon.svg";
import { ReactComponent as BrandCopyIcon } from "../../assets/icons/BrandCopyIcon.svg";

import { returnErrors } from "../../store/reducers/error";
import { setIsLoading } from "../../store/reducers/authSlice";
import moment from "moment";
import Select from "react-select";
import { statusClassMap } from "../../utils/string";
import { Pagination } from "@mui/material";
import { toast } from "react-toastify";
import { DatePicker } from "antd";
import "antd/dist/reset.css";

const { RangePicker } = DatePicker;

function PaymentReport() {
  const [searchedUser, setSearchUser] = useState([]);
  const [searchDropDown, setSearchDropDown] = useState(false);
  const [search, setSearch] = useState(null);
  const dropdownRef = useRef(null);
  const { selectedBrand } = useSelector((state) => state.brand);

  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  const planOptions = [
    { label: "All", value: null },
    { label: "1 Step EE", value: "1 Step EE Challenge" },
    { label: "2 Step EE", value: "2 Step EE Challenge" },
    ...(selectedBrand?.brand === "equity_edge"
      ? [
          { label: "1 Step Swift", value: "1 Step Swift Challenge" },
          { label: "2 Step Swift", value: "2 Step Swift Challenge" },
          { label: "Pro Edge Account", value: "Pro Edge account" },
        ]
      : [
          {
            label: "Crypto Edge Instant Funding",
            value: "Crypto Edge Instant Funding",
          },
        ]),
  ];
  const statusOptions = [
    { label: "All", value: null },
    { label: "Open", value: "open" },
    { label: "Succeeded", value: "succeeded" },
  ];
  const [plan, setPlan] = useState(null);
  const [status, setStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
  };

  const [isDeleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [deleteConfirmationModalContent, setDeleteConfirmationModalContent] =
    useState(null);
  const [platform, setPlatform] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <div className="payments_table">
      <div className="table_scroll_wrapper">
        <div className="alltable">
          <div className="alltable_header">
            <form
              // style={{ marginTop: "20px" }}
              className="search_container"
              onSubmit={(e) => {
                e.preventDefault();
                setSearch(searchValue);
                // setSearchValue()
                setCurrentPage(1);
              }}
            >
              <input
                type="text"
                placeholder="Search..."
                onChange={handleSearchChange}
              />
              <button type="submit">
                <div
                  style={{ padding: "3px 10px 0 0", width: "20px !important" }}
                >
                  <SearchNew width={"20px"} />
                </div>
              </button>
            </form>
            <button
              type="button"
              className="export-btn"
              onClick={() => setIsExportModalOpen(true)}
            >
              Export Data
            </button>
          </div>

          <div className="table_wrapper">
            <div className="table_scroll_wrapper">
              <Table
                search={search}
                searchValue={searchValue}
                plan={plan?.value}
                currentPage={currentPage}
                status={status?.value}
                platform={platform}
                setDeleteConfirmationModalOpen={setDeleteConfirmationModalOpen}
                setDeleteConfirmationModalContent={
                  setDeleteConfirmationModalContent
                }
                setCurrentPage={setCurrentPage}
              />
            </div>
          </div>
        </div>

        {isDeleteConfirmationModalOpen && (
          <DeleteModal
            isModalOpen={isDeleteConfirmationModalOpen}
            closeModal={() => setDeleteConfirmationModalOpen(false)}
            deleteContent={deleteConfirmationModalContent}
          />
        )}

        {isExportModalOpen && (
          <ExportModal
            isOpen={isExportModalOpen}
            onClose={() => setIsExportModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
}
const handleCopyToClipboard = (text) => {
  toast("Copied email", {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    type: "success",
    theme: "dark",
    className: "custom-toast-container",
  });
};
export default PaymentReport;

const Table = ({
  search,
  status,
  searchValue,
  plan,
  platform,
  currentPage,
  setCurrentPage,
}) => {
  const [filter, setFilter] = useState(null);
  const [isCalender, setIsCalender] = useState(false);
  const [date, setDate] = useState(new Date());
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();
  // const coupon = useSelector((state) => state.coupon.coupon);
  const [tableData, setTableData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [pageNumbers, setPageNumbers] = useState([]);
  console.log(search, searchValue, "status,searchValuestatus,searchValue");
  const { selectedBrand } = useSelector((state) => state.brand);

  const fetch = async () => {
    dispatch(setIsLoading(true));

    const response = await getPaymentReport(
      idToken,
      search,
      status,
      plan,
      currentPage ? currentPage : 1,
      searchValue,
      platform,
      selectedBrand
    );
    if (response?.status < 399) {
      setTableData(response.data.results);

      setTotalPages(Math.ceil(response?.data?.count / 21));
    } else {
      dispatch(returnErrors("Error getting payment list"));
    }
    dispatch(setIsLoading(false));
  };
  useEffect(() => {
    fetch();
  }, [idToken, filter, search, status, plan, currentPage, platform]);

  // const data = tableData;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Pagination Logic

  // setting total pages
  useEffect(() => {
    setPageNumbers([...Array(totalPages).keys()].map((i) => i + 1));
  }, [totalPages]);

  const handlePagination = async (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [code, setCode] = useState();
  const handleDelete = (couponCode) => {
    setCode(couponCode);
  };

  const handleFilter = (status) => {
    setFilter(status);
  };

  const filteredData =
    filter === "All"
      ? tableData
      : filter === true
      ? tableData.filter((item) => item.is_active === true)
      : tableData.filter((item) => item.is_active === false);

  const columns = React.useMemo(
    () => [
      { Header: "Email", accessor: "email" },

      { Header: "Challenge", accessor: "challenge" },
      { Header: "Plan", accessor: "plan" },

      { Header: "Stage 1", accessor: "stage1" },
      {
        Header: "Stage 1 Status",
        accessor: "stage1_status",
      },

      { Header: "Stage 2", accessor: "stage2" },
      {
        Header: "Stage 2 Status",
        accessor: "stage2_status",
      },

      { Header: "Funded", accessor: "funded_proedge" },
      {
        Header: "Funded Status",
        accessor: "funded_proedge_status",
      },

      { Header: "Coupon", accessor: "code" },
      { Header: "Country", accessor: "country" },

      { Header: "Invoice ID", accessor: "invoice_id" },

      {
        Header: "Purchase Date",
        accessor: "purchase_date",
        Cell: ({ value }) =>
          value ? moment.utc(value).format("YYYY-MM-DD") : "NA",
      },

      { Header: "Payment Mode", accessor: "payment_mode" },
      { Header: "Platform", accessor: "platform" },
      { Header: "Issue Type", accessor: "issue_type" },
    ],
    []
  );
  const [inputText, setInputText] = useState("");

  // const filteredDataCoupon = tableData.filter((el) => {
  //
  //   return el.code.toLowerCase().includes(inputText);
  // });
  //

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: tableData });
  const handleChange = (e, value) => {
    setCurrentPage(value);
  };

  const [gotoPageInput, setGotoPageInput] = useState();

  const handleGotoPage = () => {
    const pageNumber = parseInt(gotoPageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      setGotoPageInput("");
    }
  };
  return (
    <div className="table_wrapper">
      <div style={{ marginTop: "20px" }} className="table_scroll">
        <table {...getTableProps()} className="leaderboard-table">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td
                      className={`${
                        cell.column.Header === "Status" ? "status_column" : ""
                      }`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>{" "}
      </div>
      {/* <div className="pagination">
        <img src={CaretLeftIcon} alt="" />
        <button
          style={{ color: `${currentPage === 1 ? "#a8a8a8" : "black"}` }}
          onClick={() => {
            if (currentPage === 1) {
              return;
            } else {
              handlePagination(currentPage - 1);
            }
          }}
        >
          Previous
        </button>
        <span style={{ display: "flex", gap: "15px", fontWeight: "100" }}>
          {pageNumbers.map((pageNumber, idx) => (
            <strong key={pageNumber}>
              {currentPage === pageNumber ? (
                <span
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontWeight: "900",
                  }}
                >
                  {pageNumber}
                </span>
              ) : (
                <div
                  onClick={() => {
                    handlePagination(pageNumber);
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontWeight: "20",
                    padding: "4px",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    cursor: "pointer",
                  }}
                >
                  {pageNumber}
                </div>
              )}
            </strong>
          ))}
        </span>
        <button
          style={{
            color: `${currentPage + 1 > totalPages ? "#a8a8a8" : "black"}`,
          }}
          onClick={() => {
            if (currentPage + 1 > totalPages) {
              return;
            } else {
              handlePagination(currentPage + 1);
            }
          }}
        >
          Next
        </button>
        <img src={CaretRightIcon} alt="" />
      </div> */}
      <div className="spacerT30p"></div>
      <div
        className="pagination_wrapper"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "20px 0px",
        }}
      >
        <Pagination
          onChange={handleChange}
          count={totalPages}
          variant="outlined"
          page={currentPage}
          color="primary"
        />
        <div className="goto-page-input">
          <input
            type="number"
            placeholder="Go to Page"
            value={gotoPageInput}
            onChange={(e) => setGotoPageInput(e.target.value)}
          />
          <button className="goToButton" onClick={handleGotoPage}>
            Go
          </button>
        </div>
      </div>
    </div>
  );
};

const DeleteModal = ({
  isModalOpen,
  closeModal,
  deleteContent,
  onConfirmDelete,
  idToken,
}) => {
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(deleteCoupon({ idToken: idToken, code: deleteContent }));
    closeModal();
  };

  return (
    <div className="modal">
      <div className="modal_content">
        <p>Are you sure you want to delete?</p>
        <div className="modal_btn">
          <button onClick={handleDelete}>Yes</button>
          <button onClick={closeModal}>No</button>
        </div>
      </div>
    </div>
  );
};

const ExportModal = ({ onClose }) => {
  const { idToken } = useSelector((state) => state.auth);
  const { selectedBrand } = useSelector((state) => state.brand);
  const dispatch = useDispatch();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [broker, setBroker] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");

  const [country, setCountry] = useState([]);
  const [plans, setPlans] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [userEmail, setUserEmail] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [promoCode, setPromoCode] = useState([]);

  const dummyOptions = [
    { label: "Option 1", value: "option_1" },
    { label: "Option 2", value: "option_2" },
    { label: "Option 3", value: "option_3" },
  ];

  const handleExport = async () => {
    dispatch(setIsLoading(true));

    const res = await getPaymentReport(
      idToken,
      null,
      null,
      null,
      1,
      null,
      null,
      selectedBrand,
      {
        export: "csv",
        start_date: startDate,
        end_date: endDate,
        broker,
        payment_status: paymentStatus,
        country,
        plans,
        challenges,
        user_email: userEmail,
        payment_method: paymentMethod,
        promo_code: promoCode,
      }
    );

    if (res?.status < 399) {
      const blob = new Blob([res.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", "payment-report.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("CSV Exported Successfully");
      onClose();
    } else {
      toast.error("Export failed");
    }

    dispatch(setIsLoading(false));
  };

  return (
    <div className="modal">
      <div className="modal_content export_modal">
        <h3>Export Payment Report</h3>

        <div className="grid">
          <RangePicker
            className="ant-white-range"
            onChange={(dates) => {
              setStartDate(dates?.[0]?.format("YYYY-MM-DD") || "");
              setEndDate(dates?.[1]?.format("YYYY-MM-DD") || "");
            }}
          />

          <input
            placeholder="Broker"
            onChange={(e) => setBroker(e.target.value)}
          />
          <input
            placeholder="Payment Status"
            onChange={(e) => setPaymentStatus(e.target.value)}
          />

          <Select
            isMulti
            options={dummyOptions}
            placeholder="Country"
            onChange={(v) => setCountry(v.map((i) => i.value))}
          />
          <Select
            isMulti
            options={dummyOptions}
            placeholder="Plans"
            onChange={(v) => setPlans(v.map((i) => i.value))}
          />
          <Select
            isMulti
            options={dummyOptions}
            placeholder="Challenges"
            onChange={(v) => setChallenges(v.map((i) => i.value))}
          />
          <Select
            isMulti
            options={dummyOptions}
            placeholder="User Email"
            onChange={(v) => setUserEmail(v.map((i) => i.value))}
          />
          <Select
            isMulti
            options={dummyOptions}
            placeholder="Payment Method"
            onChange={(v) => setPaymentMethod(v.map((i) => i.value))}
          />
          <Select
            isMulti
            options={dummyOptions}
            placeholder="Promo Code"
            onChange={(v) => setPromoCode(v.map((i) => i.value))}
          />
        </div>

        <div className="modal_btn">
          <button onClick={handleExport}>Export CSV</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};
